<template>
    <div data-scroll-to-active="true" class="main-menu menu-fixed menu-dark menu-accordion menu-shadow">     
      <div class="main-menu-content">
        <ul id="main-menu-navigation" data-menu="menu-navigation" class="navigation navigation-main">          
          
          <li class="nav-item">
            <router-link :to="{ name: 'dashboard'}">
              <i class="icon-home3"></i>
              <span class="menu-title">{{ $t('titles.dashboard')}}</span>
            </router-link>
          </li> 
            <li class="nav-item" v-if="userRole == 'admin' || userRole == 'logist'">
              <router-link :to="{ name: 'users'}">
                <i class="icon-users2"></i>
                <span class="menu-title">{{ $t('titles.users')}}</span>
              </router-link>
          </li>

          <!-- <li class="nav-item">
            <router-link :to="{ name: 'transport_tender'}">
              <i class="icon icon-paste"></i>
              <span class="menu-title">{{ $t('titles.transport_tender')}}</span>
            </router-link>
          </li>
          

          <li class="nav-item">
            <router-link :to="{ name: 'user_tender'}">
              <i class="icon icon-clipboard"></i>
              <span class="menu-title">{{ $t('titles.user_tender')}}</span>
            </router-link>
          </li> -->




          <li class="nav-item has-sub" v-if="userRole == 'admin' || userRole == 'logist' || userRole == 'client'">
            <a>
              <i class="icon-paste"></i>
              <span class="menu-title">{{ $t('titles.transport_tender')}}</span>
            </a>
            <ul class="menu-content">
              <li class="nav-item">
            <router-link :to="{ name: 'transport_tender'}">
              <i class="icon icon-paste"></i>
              <span class="menu-title">{{ $t('titles.active')}}</span>
            </router-link>
            </li>
            <li class="nav-item">
            <router-link :to="{ name: 'user_tender'}">
              <i class="icon icon-clipboard"></i>
              <span class="menu-title">{{ $t('titles.user_tender')}}</span>
            </router-link>
            </li>             
                        
            </ul>
          </li> 


          <li class="nav-item has-sub" v-if="userRole == 'admin' || userRole == 'logist' || userRole == 'client'">
            <a>
              <i class="icon-office"></i>
              <span class="menu-title">{{ $t('titles.flights')}}</span>
            </a>
            <ul class="menu-content">
              <li class="nav-item">
            <router-link :to="{ name: 'active_flights'}">
              <i class="icon icon-truck"></i>
              <span class="menu-title">{{ $t('titles.active')}}</span>
            </router-link>
            </li>
            <li class="nav-item">
            <router-link :to="{ name: 'completed_flights'}">
              <i class="icon icon-truck"></i>
              <span class="menu-title">{{ $t('titles.completed')}}</span>
            </router-link>
            </li>              
                        
            </ul>
          </li> 
          
          <li class="nav-item has-sub" v-if="userRole == 'admin' || userRole == 'logist' || userRole == 'user'">
            <a>
              <i class="icon-office"></i>
              <span class="menu-title">{{ $t('titles.reports')}}</span>
            </a>
            <ul class="menu-content">
              <!-- <li class="nav-item">
                <router-link :to="{ name: 'online_monitoring'}">
                  <span class="menu-title">{{ $t('titles.online_monitoring')}}</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="{ name: 'front_office'}">
                  <span class="menu-title">{{ $t('titles.front_office')}}</span>
                </router-link>
              </li> -->
              <li class="nav-item">
                <router-link :to="{ name: 'transport_request'}">
                  <span class="menu-title" v-if="userRole == 'admin' || userRole == 'logist'">{{ $t('titles.transport_request')}}</span>
                  <span class="menu-title" v-if="userRole == 'user'">{{ $t('table.my-orders')}}</span>
                </router-link>
              </li>             
            </ul>
          </li>
          <!-- <li class="nav-item" v-if="$store.state.listRole.dispatcher || $store.state.listRole.admin">
              <router-link :to="{ name: 'users'}"><a>
                <i class="icon-users2"></i>
                <span class="menu-title">{{ $t('titles.users')}}</span>
              </a></router-link>
          </li>           -->
           <!-- <li class="nav-item">
            <router-link :to="{ name: 'user_messages'}">
              <i class="ficon icon-bell4"></i>
              <span class="menu-title">{{ $t('titles.user_messages')}}</span>
            </router-link>
          </li> -->

          <li class="nav-item has-sub" v-if="userRole == 'client'">
            <a>
              <i class="ficon icon-bell4"></i>
             <span class="menu-title">{{ $t('titles.user_messages')}}</span>
            </a>
            <ul class="menu-content">
              <li class="nav-item">
            <router-link :to="{ name: 'active_flights'}">
              <i class="ficon icon-bell4"></i>
             <span class="menu-title">{{ $t('titles.user_messages')}}</span>
            </router-link>
            </li>
            <li class="nav-item">
            <router-link :to="{ name: 'contact_as'}">
              <i class="ficon icon-bell4"></i>
              <span class="menu-title">{{ $t('titles.contactAs')}}</span>
            </router-link>
            </li>              
                        
            </ul>
          </li> 







        </ul>
      </div>

    </div>
</template>
<script>

    export default {
      name: "Sidebar",
      data() {
        return {
          
        }
      },
      methods: {
        
      },
      computed:{
         userRole(){
            if(this.$store.getters.getUserRoleAdmin){
                return  "admin"    
            }
            else if (this.$store.getters.getUserRoleLogist) {             
              return "logist"
            }
            else if (this.$store.getters.getUserRoleClient) {             
              return "client"
            }
            else return "user"
           
        },
         
      },
      mounted(){
               
      },
      created(){
        
      }
    }

</script>
<style>
    
</style>


// WEBPACK FOOTER //
// src/components/menu/Sidebar.vue